module.exports = __webpack_public_path__ + "img/8.d12f1197.jpg";